import React from 'react';
import BaseModal, {
	BaseModalProps,
} from '../../../Base/Components/BaseModal/BaseModal';
import { Document } from '../../../../graphql/graphql';
import CSSZSickLeaveCertificateSubmissionsOverview from './CSSZSickLeaveCertificateSubmissionsOverview';

interface Props extends BaseModalProps {
	submissions: Document[];
}

const CSSZSickLeaveCertificateSubmissionsOverviewModal = ({
	submissions,
	onClose,
	...baseModalProps
}: Props) => {
	return (
		<BaseModal
			title='component.CSSZSickLeaveCertificateDetailControls.submissionOverview'
			onClose={onClose}
			{...baseModalProps}>
			<CSSZSickLeaveCertificateSubmissionsOverview submissions={submissions} />
		</BaseModal>
	);
};

export default CSSZSickLeaveCertificateSubmissionsOverviewModal;
